import React, { useEffect, useState } from 'react';
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CardContent,
  Card,
  Dialog,
  ButtonGroup,
  Button,
  Switch,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { validateMaterialToSell, getCheckedMaterialsForSell, validateDuplicatedSerialNumber } from '../../helperFunctions';
import { setMaterialSellDialog } from '../redux';

export default () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();

  const { sellMaterials } = useSelector(state => state.tasks.data);
  const materialSellDialog = useSelector(state => state.tasks.materialSellDialog);
  // TODO: fix render issue
  // eslint-disable-next-line no-unused-vars
  const [renderHack, setRenderHack] = useState();
  const [checkedMaterials, setCheckedMaterials] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const fontSize = width <= 500 ? '4vw' : '20px';
  const smallerFontSize = width <= 500 ? '3.5vw' : '18px';

  // Get selected free materials
  const newUsedMaterials = useSelector(state => state.tasks.newUsedMaterials);
  const data = useSelector(state => state.tasks.data);
  const showTaskDetails = useSelector(state => state.tasks.showTaskDetails);
  const task = data.tasks.find(z => z.id === showTaskDetails.taskId);
  const taskEnded = task && task.appEnd;

  useEffect(() => {
    if (!materialSellDialog.open || !materialSellDialog.taskId) return;
    getCheckedMaterialsForSell(materialSellDialog.taskId, dispatch).then(response => {
      if (Array.isArray(response)) {
        setRenderHack(new Date());
        setCheckedMaterials(response);
      } else {
        setCheckedMaterials([]);
      }
      setIsDataLoaded(true);
    });
  }, [materialSellDialog, dispatch]);

  const updateMaterial = serialNumber => {
    setRenderHack(new Date());
    if (!serialNumber) return;

    let newCheckedMaterials = [...checkedMaterials];

    if (newCheckedMaterials.includes(serialNumber)) {
      newCheckedMaterials = newCheckedMaterials.filter(el => serialNumber !== el);
    } else {
      newCheckedMaterials.push(serialNumber);
    }

    setCheckedMaterials(newCheckedMaterials);
  };

  const saveMaterials = async () => {
    const selectedData = sellMaterials.filter(x => checkedMaterials.includes(x.serialNumber));
    const isDuplicated = validateDuplicatedSerialNumber(selectedData, newUsedMaterials, dispatch, true, taskEnded);
    if (isDuplicated) return;
    const isValid = await validateMaterialToSell(selectedData, materialSellDialog.taskId, dispatch);
    if (isValid)
      dispatch(setMaterialSellDialog({ open: false, readonly: false, taskId: undefined }));
  };

  return (
    materialSellDialog.open && (
      <Dialog open={materialSellDialog.open} fullScreen>
        <ButtonGroup style={{ position: 'sticky', width: '100%', top: '0', zIndex: '100' }}>
          <Button
            onClick={() => {
              dispatch(setMaterialSellDialog({ open: false, readonly: false, taskId: undefined }));
              setIsDataLoaded(false);
            }}
            variant="contained"
            style={{ width: materialSellDialog.readonly ? '100%' : '50%' }}
          >
            <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
              Затвори
            </Typography>
          </Button>
          {!materialSellDialog.readonly && (
            <Button
              onClick={saveMaterials}
              variant="contained"
              color="secondary"
              style={{ width: '50%' }}
            >
              <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
                Запази
              </Typography>
            </Button>
          )}
        </ButtonGroup>
        <Card style={{ marginTop: '3px', overflow: 'scroll' }}>
          <CardContent>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize }} size="small">
                    Име
                  </TableCell>
                  <TableCell style={{ fontSize }} size="small">
                    Сер. номер
                  </TableCell>
                  <TableCell style={{ fontSize }} size="small">
                    Кол.
                  </TableCell>
                  {!materialSellDialog.readonly && (
                    <TableCell style={{ fontSize }} size="small">
                      Избрано
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {sellMaterials.map(x => (
                  <TableRow key={x.serialNumber}>
                    <TableCell style={{ fontSize }} size="small">
                      {x.materialName}
                    </TableCell>
                    <TableCell style={{ fontSize }} size="small">
                      {x.serialNumber}
                    </TableCell>
                    <TableCell style={{ fontSize }} size="small">
                      {x.quantity}
                    </TableCell>
                    {isDataLoaded && !materialSellDialog.readonly && (
                      <TableCell style={{ fontSize }} size="small">
                        <SellSwitch
                          handleChange={() => updateMaterial(x.serialNumber)}
                          def={checkedMaterials.includes(x.serialNumber)}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </Dialog>
    )
  );
};

const SellSwitch = props => {
  const [checked, setChecked] = useState(props.def);
  //useEffect(() => setChecked(props.def), [props.def]);
  return (
    <Switch
      checked={checked}
      onChange={() => {
        setChecked(c => !c);
        props.handleChange();
      }}
    />
  );
};
